import type { CelestialBodyDefinition } from "../types/celestialBody";
import { J2000_JD, SUN_MU_KM3_S2 } from "../astronomy/constants";

/** Fonte: valores médios aproximados (NASA/JPL Fact Sheets). */
export const sun: CelestialBodyDefinition = {
  id: "sun",
  name: "Sol",
  englishName: "Sun",
  type: "star",
  parentId: null,
  physical: {
    meanRadiusKm: 695_700,
    equatorialRadiusKm: 695_700,
    massKg: 1.9885e30,
    surfaceGravityMS2: 274,
    escapeVelocityKmS: 617.7,
  },
  rotation: {
    siderealRotationPeriodHours: 609.12,
    axialTiltDeg: 7.25,
    rotationDirection: "prograde",
    epochJulianDate: J2000_JD,
  },
  color: "#FDB813",
  textureKey: "sun",
  description: "Estrela central do Sistema Solar",
  enabledByDefault: true,
  renderPriority: 0,
  gravitationalParameterKm3S2: SUN_MU_KM3_S2,
};
